import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Translate } from 'react-localize-redux';
import styled, { css } from 'styled-components';

import SegmentedTranslate from '../../hocs/segmented-translate';
import TARO from './images/taro.png';
import { slideIn } from './keyframes';
import Section from './section';

const TaroSays = styled.div`
  display: flex;
  align-items: center;

  opacity: 0;
  transform: translate(100%, -2.5em);

  ${({ inView }) =>
    inView &&
    css`
      animation: ${slideIn} 0.7s cubic-bezier(0, 1, 0, 1) both;
    `}
`;

const Taro = styled.img`
  margin: 0 0.25em 0 1.5em;
  transform: translateY(17.5%);
  width: 4em;
  z-index: -1;
`;

const TaroText = styled.div`
  color: #ffffff;
`;

const StepContainer = styled.div`
  display: flex;

  opacity: 0;
  transform: translate(100%, -2.5em);

  ${({ inView, delay }) =>
    inView &&
    css`
      animation: ${slideIn} 0.7s cubic-bezier(0, 1, 0, 1) ${delay} both;
    `}

  &:not(:last-of-type) {
    margin-bottom: 2.2em;
    position: relative;

    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: -30px;
      left: 50%;
      transform: translateX(-50%);
      border: 15px solid transparent;
      border-top-color: #ffffff;
    }
  }
`;

const StepNumber = styled.div`
  align-items: center;
  background: ${props => props.theme.primary};
  color: #ffffff;
  display: flex;
  font-family: DINCondensed-Regular;
  font-size: 2em;
  padding: 0 1em;
`;

const StepContent = styled.div`
  background: #ffffff;
  flex: 1;
  padding: 1.25em 1em;
`;

const StepTitle = styled.div`
  font-family: 'Noto Serif JP', serif;
  font-size: 1.25em;
  font-weight: bold;
  margin-bottom: 0.5em;
`;

const StepText = styled.div`
  font-size: 0.75em;
  line-height: 1.5;
`;

const Step = ({ number, ...rest }) => {
  return (
    <StepContainer {...rest}>
      <StepNumber>{number}</StepNumber>
      <StepContent>
        <StepTitle>
          <SegmentedTranslate
            id={`psyLandingPage.instructions.${number}.title`}
          />
        </StepTitle>
        <StepText>
          <SegmentedTranslate
            id={`psyLandingPage.instructions.${number}.text`}
          />
        </StepText>
      </StepContent>
    </StepContainer>
  );
};

/**
 * Instruction section
 */
const Instructions = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 1 });
  return (
    <Section
      heading="PARTICIPATE"
      subHeading={<Translate id="psyLandingPage.instructions.subtitle" />}
    >
      <div ref={ref} />
      <TaroSays inView={inView}>
        <Taro src={TARO} />
        <TaroText>
          <Translate id="psyLandingPage.instructions.taro" />
        </TaroText>
      </TaroSays>
      <Step delay="0s" inView={inView} number={1} />
      <Step delay="0.2s" inView={inView} number={2} />
      <Step delay="0.4s" inView={inView} number={3} />
    </Section>
  );
};

export default Instructions;
